"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAnimating;

var _react = require("react");

var _StateContext = _interopRequireDefault(require("../ScrollToBottom/StateContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useAnimating() {
  var context = (0, _react.useContext)(_StateContext.default);
  return [context.animating];
}